var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"video-block"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-lg-10 offset-lg-1"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.src,"allowfullscreen":""}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }